import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import AuthPrimaryButton from "@/components/AuthPrimaryButton";
import P from "@/components/P";
import Select from "@/components/Select";
import SmallButton from "@/components/SmallButton";
import Spacer from "@/components/Spacer";
import bandsintown from "@/images/bandsintown.png";
// import AppState from "@/store/appstate";
import useAppStore from "@/store/appStateZustand";

function AddBandsintown() {
  const { t } = useTranslation("onboarding");
  const navigate = useNavigate();

  // const apiUrl = AppState.getRawState()?.apiUrl;
  // const bandsintownResult = AppState.useState(s => s.addAccount.bandsintown);

  const apiUrl = useAppStore(state => state.apiUrl);
  const bandsintownResult = useAppStore(state => state.addAccount?.bandsintown);

  const getOptions = query => new Promise((resolve, reject) => {
    if (!query) {
      resolve([]);
      return;
    }
    fetch(`${apiUrl}/bandsintown?s=${query}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(response => response.json()).then((data) => {
      resolve([{ value: JSON.stringify(data), name: data.name, photo: data.thumb_url }]);
    }).catch(reject);
  });

  return (
    <div className="container mx-auto">
      <div className="flex flex-col items-center justify-center p-4 text-center text-white min-h-screen-minus-footer">

        <img width="80" src={bandsintown} alt="bandsintown logo" />
        <Spacer />
        {!bandsintownResult
          && (
            <>
              <h1 className="text-6xl">{t("onboarding:add-bandsintown-header")}</h1>
              <Spacer />
              <P>{t("onboarding:add-bandsintown-desc")}</P>
              <Spacer />
              <div className="relative flex flex-col items-center justify-center w-full">
                <div className="w-full lg:w-1/3">
                  <div className="flex flex-row items-start justify-center w-full text-ink-primary">
                    <Select
                      authSearch
                      className="custom-select no-dropdown"
                      debounce={500}
                      onChange={(artist) => {
                        // AppState.update((s) => {
                        //   s.addAccount.bandsintown = artist;
                        // });
                        useAppStore.getState().setAddAccountSocial("bandsintown", artist);
                      }}
                      getOptions={getOptions}
                      placeholder={t("onboarding:search-bandsintown-placeholder")}
                      search
                      customLabel="Bandsintown Artist Name"
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        {!!bandsintownResult
          && (
            <>
              <h1 className="text-6xl">{t("onboarding:selected-bandsintown-profile")}</h1>
              <Spacer />
              <div className="flex flex-col items-center p-4 px-6 bg-white rounded-lg shadow-lg text-ink-primary">
                {JSON.parse(bandsintownResult).thumb_url && JSON.parse(bandsintownResult).thumb_url.length > 0
                  && (
                    <img
                      className="object-cover w-20 h-20 mb-4 rounded-full"
                      alt={JSON.parse(bandsintownResult).name}
                      src={JSON.parse(bandsintownResult).thumb_url}
                    />
                  )}
                {(!JSON.parse(bandsintownResult).thumb_url)
                  && <div className="w-20 h-20 mb-4 bg-gray-300 rounded-full" />}
                <p className="mb-4 font-bold">{JSON.parse(bandsintownResult).name}</p>
                <SmallButton onClick={() => {
                  // AppState.update((s) => {
                  //   s.addAccount.bandsintown = null;
                  // });
                  useAppStore.getState().setAddAccountSocial("bandsintown", null);
                }}
                >
                  {t("common:remove")}
                </SmallButton>
              </div>

            </>
          )}
        <Spacer />

        <div className="flex flex-row justify-center w-full lg:w-1/3">
          <AuthPrimaryButton
            onClick={() => navigate({ to: "/add-account-5" })}
          >
            {t("common:_done")}
          </AuthPrimaryButton>
        </div>
        <Spacer />

      </div>
    </div>
  );
}

export default AddBandsintown;
